import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Login from "./pages/Login";
import Register from "./pages/Register";
import EmailVerified from "./pages/EmailVerified";
import Header from "./components/Header";
import DashboardLayout from "./layouts/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import DetailRoom from "./pages/DetailRoom";
import PrivateRoute from "./routes/PrivateRoute";
import { AuthProvider } from "./context/AuthContext";
import DetailBooking from "./components/DetailBooking";
import Booking from "./pages/Booking";
import Confirmation from "./pages/Confirmation";
import DetailReservation from "./pages/Detailreservation";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import DetailBlog from "./pages/DetailBlog";
import Facility from "./components/Facility";
import Favorite from "./pages/Favorite";
import RatingByUser from "./pages/RatingByUser";
import RoomLogged from "./pages/RoomLogged";
import Activities from "./pages/Activities";
import ActivityDetail from "./pages/ActivityDetail";
import axios from "axios";
import Notifications from "./pages/Notifications";
import DetailNotification from "./pages/DetailNotification";
import { NotificationProvider } from "./context/NotificationContext";
import { CompanyProvider } from "./context/CompanyContext";
import { getCompanyData } from "./helpers/getCompanyData";
import VerifyOtp from "./pages/VerifyOtp";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyResetOtp from "./pages/VerifyResetOtp";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    const storedCompany = localStorage.getItem("company");
    if (storedCompany) {
      setCompany(JSON.parse(storedCompany));
    } else {
      const fetchCompany = async () => {
        const data = await getCompanyData();
        if (data) {
          setCompany(data);
          localStorage.setItem("company", JSON.stringify(data));
        }
      };
      fetchCompany();
    }
  }, []);

  useEffect(() => {
    if (company) {
      document.title = company.name;
      changeFavicon(company.logo || "/favicon.ico");
    }
  }, [company]);

  const changeFavicon = (faviconUrl) => {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = faviconUrl;
    }
  };

  return (
    <CompanyProvider>
      <NotificationProvider>
        <AuthProvider>
          <Router>
            <Header
              darkMode={darkMode}
              toggleDarkMode={() => setDarkMode(!darkMode)}
            />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-otp" element={<VerifyOtp />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/verify-reset-otp" element={<VerifyResetOtp />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<DetailBlog />} />
              <Route path="/facility/swimming-pool" element={<Facility />} />
              <Route path="/email-verified" element={<EmailVerified />} />
              <Route path="/detail-booking" element={<DetailBooking />} />
              <Route path="/detail-room/:id" element={<DetailRoom />} />
              <Route
                path="/booking"
                element={
                  <PrivateRoute>
                    <Booking />
                  </PrivateRoute>
                }
              />
              <Route
                path="/confirmation"
                element={
                  <PrivateRoute>
                    <Confirmation />
                  </PrivateRoute>
                }
              />

              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardLayout />
                  </PrivateRoute>
                }
              >
                <Route index element={<DashboardHome />} />
                <Route
                  path="reservation-detail"
                  element={<DetailReservation />}
                />
                <Route path="favorite" element={<Favorite />} />
                <Route path="ratings" element={<RatingByUser />} />
                <Route path="rooms" element={<RoomLogged />} />
                <Route path="activities" element={<Activities />} />
                <Route path="activities/:id" element={<ActivityDetail />} />
                <Route path="notifications" element={<Notifications />} />
                <Route
                  path="notifications/:id"
                  element={<DetailNotification />}
                />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </NotificationProvider>
    </CompanyProvider>
  );
}

export default App;
